import { Navigate } from "react-router-dom";
import { getUserLocal } from "./localStorage.util";

export const formatDate = (date) => {
  if (!date) return "-";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleString("en-in", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const inchargeNameChange = (name) => {
  switch (name) {
    case "State":
      return "Admin";
    case "Division":
    case "DSP":
      return "DSP";
    case "Platinum":
      return "Platinum";
    case "Diamond":
      return "Diamond";
    case "Gold":
      return "Gold";
    case "Silver":
      return "Silver";
    case "Bronze":
      return "Bronze";
    case "Block":
      return "General Manager";
    case "Cluster":
      return "Marketing Manager";
    case "Franchise":
      return "Sales Officer";
    case "Admin":
      return "Administrator";
    case "Village":
      return "Field Officer";
    case "Employee":
      return "Employee";
    default:
      return name || "Staff";
  }
};

export const Protected = ({ isLoggedIn, children }) => {
  const user = isLoggedIn || getUserLocal();
  if (!user) {
    return <Navigate to="/" replace />;
  } else {
    if (user.Type !== "Admin") {
      return <Navigate to="/inchargeDashboard" replace />;
    }
    return children;
  }
};

export const ProtectedStaff = ({ isLoggedIn, children }) => {
  const user = isLoggedIn || getUserLocal();
  if (!user) {
    return <Navigate to="/" replace />;
  }
  return children;
};
